import axios from 'axios'

const railwayApi = axios.create({
  baseURL: process.env.VUE_APP_RAILWAY_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-API-Key': process.env.VUE_APP_RAILWAY_API_KEY,
  },
  timeout: 10000,
})

export const RailwayApiService = {
  /**
   * Sync contractor approval status to Supabase via Railway API
   * Fire-and-forget: errors are logged but do not block the caller
   */
  async syncContractorApproval(ticketNum, approved, approvedBy) {
    try {
      const response = await railwayApi.post('/sql/updateContractorApproval', {
        TicketNum: ticketNum,
        ContractorApproved: approved ? 'Yes' : 'No',
        ContractorApprovedBy: approvedBy,
        DateContractorApproved: new Date().toISOString(),
      })
      console.log('Railway sync (approval) success:', response.data)
      return response.data
    } catch (error) {
      console.error('Railway sync (approval) failed:', error?.response?.data || error.message)
      return { success: false, error: error.message }
    }
  },

  /**
   * Sync contractor invoiced status to Supabase via Railway API
   * Fire-and-forget: errors are logged but do not block the caller
   */
  async syncContractorInvoiced(ticketNums, invoicedBy, invoiceNumber) {
    try {
      const response = await railwayApi.post('/sql/updateContractorInvoiced', {
        TicketNums: ticketNums,
        ContractorInvoiced: 'Yes',
        ContractorInvoicedBy: invoicedBy,
        ContractorInvoicedDate: new Date().toISOString(),
        ContractorInvoicedNumber: invoiceNumber,
      })
      console.log('Railway sync (invoiced) success:', response.data)
      return response.data
    } catch (error) {
      console.error('Railway sync (invoiced) failed:', error?.response?.data || error.message)
      return { success: false, error: error.message }
    }
  },
}
